import React from 'react';

export const StakeholderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
  >
    <path
      d="M19.2039 18.0706C20.1122 18.0706 20.8484 18.8124 20.8484 19.7275V20.4042C20.8484 20.8267 20.7174 21.2386 20.4736 21.5823C19.3432 23.1761 17.4972 23.9658 14.9961 23.9658C12.4944 23.9658 10.6494 23.1758 9.52166 21.5811C9.2789 21.2378 9.14844 20.8268 9.14844 20.4053V19.7275C9.14844 18.8124 9.88472 18.0706 10.793 18.0706H19.2039ZM14.9961 9.23242C17.0154 9.23242 18.6524 10.8818 18.6524 12.9164C18.6524 14.951 17.0154 16.6004 14.9961 16.6004C12.9767 16.6004 11.3397 14.951 11.3397 12.9164C11.3397 10.8818 12.9767 9.23242 14.9961 9.23242Z"
      fill="#153142"
    />
    <circle cx="15" cy="15.2871" r="8.5" stroke="#153142" />
    <circle cx="15" cy="15.2871" r="11.5" stroke="#153142" />
    <circle cx="27" cy="15.2871" r="2" fill="#153142" />
    <circle cx="3" cy="15.2871" r="2" fill="#153142" />
    <circle cx="9" cy="4.7793" r="2" fill="#153142" />
    <circle cx="21.4258" cy="4.7793" r="2" fill="#153142" />
    <circle cx="9" cy="25.6699" r="2" fill="#153142" />
    <circle cx="21.4258" cy="25.6699" r="2" fill="#153142" />
  </svg>
);
